import React, { useContext } from 'react';
import { Typography, styled, Grid } from '@mui/material';
import { MarkEmailUnreadOutlined, UploadOutlined } from '@mui/icons-material';
import { SendOutlined } from '@mui/icons-material';

import { IconInlineCard } from './IconInlineCard';
import UserContext from '../context/UsersContext';
import { UsersViewTitles } from '../constant/UsersViewTitles.enum';

const CardsContainer = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
    justifyContent: 'center',
    gap: '61px',
}));

const SendingInvitationOptions: React.FC = () => {
    const { setHeader } = useContext(UserContext);

    return (
        <Grid
            item
            xs={12}
            sx={{
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            <CardsContainer>
                <IconInlineCard
                    header="Send Email"
                    description="Invite a single user via email."
                    Icon={MarkEmailUnreadOutlined}
                    widthInPx="212px"
                    heightInPx="125px"
                    onClick={() =>
                        setHeader({
                            title: UsersViewTitles.InviteUsersViaEmail,
                            Icon: SendOutlined,
                        })
                    }
                />
                <Typography variant="h5" style={{ color: '#999999' }}>
                    OR
                </Typography>
                <IconInlineCard
                    header="CSV Upload"
                    description="Upload a .csv of emails."
                    Icon={UploadOutlined}
                    widthInPx="212px"
                    heightInPx="125px"
                    onClick={() =>
                        setHeader({
                            title: UsersViewTitles.InviteUsersViaCSV,
                            Icon: SendOutlined,
                        })
                    }
                />
            </CardsContainer>
        </Grid>
    );
};

export default SendingInvitationOptions;
